import { Stack } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

type StartAdornmentProps = PropsWithChildren & {
	minWidth?: number;
	height?: number;
};

export const StartAdornment: FC<StartAdornmentProps> = (props) => {
	const { minWidth, height } = props;

	return (
		<Stack
			alignItems="center"
			justifyContent="center"
			flexGrow={1}
			sx={{
				overflow: "hidden",
				width: "max-content",
				maxWidth: "100%",
				minWidth: minWidth ?? "50px",
				height: height ?? "41px",
				borderRadius: "6px 0 0 6px",
				padding: "8px 12px",
				backgroundColor: (t) =>
					t.palette.mode === "dark"
						? t.palette.secondary.dark
						: t.palette.secondary.light,
			}}
		>
			{props.children}
		</Stack>
	);
};
